import * as Utils from '.';
export class Arr {
/**
 * Returns whether the given array has elements
 * @param {?} arr
 * @return {?}
 */
public static hasElements(arr: any[]): boolean {
    return Utils.Obj.isNotNullOrUndefined(arr) &&
      arr.length > 0;
  }
/**
 * Returns whether the array is of the given length
 * @param {?} arr
 * @param {?} length
 * @return {?}
 */
public static isOfLength(arr: any[], length: number): boolean {
    return Utils.Obj.isNotNullOrUndefined(arr) && arr.length === length;
  }
/**
 * Returns whether the given array is empty
 * @param {?} arr
 * @return {?}
 */
public static isEmpty(arr: any[]): boolean {
    return !Arr.hasElements(arr);
  }
/**
 * Returns whether the given object is an array
 * @param {?} obj
 * @return {?}
 */
public static isArray(obj: any): boolean {
    return Object.prototype.toString.call(obj) === '[object Array]';
  }
}